import {Injectable} from '@angular/core';
import {AbstractTuiValueTransformer, TuiDay, TuiTime} from '@taiga-ui/cdk';

export const dateToDateTimeInput = (
  date: string | null,
): [TuiDay | null, TuiTime | null] => {
  if (!date) {
    return [null, null];
  }
  const parsedDate = new Date(date);
  const year = parsedDate.getFullYear();
  const month = parsedDate.getMonth();
  const day = parsedDate.getDate();
  const hours = parsedDate.getHours();
  const minutes = parsedDate.getMinutes();

  return [new TuiDay(year, month, day), new TuiTime(hours, minutes, 0, 0)];
};

export const dateTimeInputToDate = (
  value: [TuiDay | null, (TuiTime | null)?],
): string | undefined => {
  if (!value) {
    return undefined;
  }
  const [date, time] = value;

  if (!date) {
    return undefined;
  }

  if (!time) {
    return new Date(date.year, date.month, date.day).toISOString();
  }

  return new Date(
    date.year,
    date.month,
    date.day,
    time.hours,
    time.minutes,
    time.seconds,
    time.ms,
  ).toISOString();
};

export const dateTimeInputToTuiDay = () => {
  const date = new Date().toDateString();

  return (
    dateToDateTimeInput(date) as [
      TuiDay,
      {hours: number; minutes: number; seconds: number; ms: number},
    ]
  )[0];
};

@Injectable()
export class ISODateTimeTransformer extends AbstractTuiValueTransformer<
  [TuiDay | null, TuiTime | null],
  string
> {
  fromControlValue(controlValue: string): [TuiDay | null, TuiTime | null] {
    const tuiDate = dateToDateTimeInput(controlValue);

    return tuiDate;
  }

  toControlValue([day, time]: [TuiDay | null, TuiTime | null]): string {
    const isoDate = dateTimeInputToDate([day, time]);

    return isoDate ?? '';
  }
}
